// 目前用于注册，忘记密码
export const captchaDateId = 'authenticationCodeSendAt'
export const captchaCountDown = 60
